import { Component, OnInit } from '@angular/core';
import { AitTransporteSituacaoLabels } from '@tivic-team/manager-ts/dist/mob';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'dropdown-situacao-ait',
  templateUrl: './dropdown-situacao-ait.component.html',
  styleUrls: ['./dropdown-situacao-ait.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class DropdownSituacaoAitComponent implements OnInit {

  constructor() { }

  aitSituacoes = AitTransporteSituacaoLabels;

  ngOnInit() { }
}
